import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';

import SiteHeaderBar from 'containers/SiteHeaderBar';

ReactDOM.render(
    <Provider store={window.store}>
        <SiteHeaderBar />
    </Provider>,
    document.getElementById('SiteHeaderBar')
);



// WEBPACK FOOTER //
// ./source/apps/siteHeaderBar.jsx